import { defineStore } from 'pinia'

export enum EVENT_BUS_EVENTS {
	COLLAPSE_WHY_WE_ASK,
	SUBMIT_FORM_ERROR,
	CANCEL_UPLOAD_IMAGES,
	UPLOAD_IMAGES_PROGRESS,
	FULL_NAME_REQUIRED,
	FORM_NEXT_STEP,
}

type eventBusName = EVENT_BUS_EVENTS | string

export const useEventBus = defineStore({
	id: 'eventBus',
	state: () => ({}),
	actions: {
		emit(arg: { name: eventBusName; data?: unknown }) {
			return arg
		},
	},
})
